import React from 'react';
import classNames from 'classnames';

const RenderPaginationButtons = (props) => {
    const { offset, limit, totalCount } = props;
    const totalPages = Math.ceil(totalCount / limit);
    const currentPage = Math.floor(offset / limit) + 1;

    // Calculate the range of page numbers to display
    const startPage = Math.max(1, currentPage - 2);
    const endPage = Math.min(totalPages, startPage + 4);

    // Generate an array of page numbers within the range
    const pageNumbers = Array.from({ length: endPage - startPage + 1 }, (_, index) => startPage + index);

    return (
        <div className='flex flex-middle ht-50'>
            <button
                className="pagination-button ht-30 paginArrow"
                onClick={() => props.goToPage(currentPage - 1)}
                disabled={currentPage === 1}
            >
                {'<'}
            </button>

            {pageNumbers.map((pageNumber) => (
                <button
                    key={pageNumber}
                    className={classNames("pagination-button ht-30", { active: (pageNumber - 1) * limit === offset })}
                    onClick={() => props.goToPage(pageNumber)}
                >
                    {pageNumber}
                </button>
            ))}

            <button
                className="pagination-button ht-30 paginArrow"
                onClick={() => props.goToPage(currentPage + 1)}
                disabled={currentPage === totalPages}
            >
                {'>'}
            </button>
        </div>
    );
}

export default RenderPaginationButtons;